import React from 'react';
import {Button} from '@albert-io/atomic';
import {storePostLoginRedirect} from 'lib/postLoginRedirect';

import './assets/social-button.scss';

interface Props extends PropsWithChildrenRequired {
  disabled: boolean;
  href: string;
  provider: 'clever' | 'google';
  stayOnCurrentPageAfterAuth?: boolean;
}

export default function SocialButton({
  children,
  disabled,
  href,
  provider,
  stayOnCurrentPageAfterAuth
}: Props) {
  const handleClick = () => {
    if (stayOnCurrentPageAfterAuth) {
      storePostLoginRedirect(window.location.pathname + window.location.search);
    }
  };

  return (
    <Button
      as='a'
      href={href}
      color={`vendor-${provider}`}
      className='sso-button'
      disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
}
